class MegaMenu {
    constructor() {
        this.buttonSelector = '.toggle-mega-menu';
        this.megaMenuSelector = '#mega-menu';
        this.init();
    }

    init() {
        this.toggleMegaMenu();
    }

    toggleMegaMenu() {
        $(this.buttonSelector).on('click', () => {
            $(this.megaMenuSelector).toggleClass('hidden')
        });
    }
}

export default MegaMenu;